import React, { ReactNode } from 'react';
import { TFunction } from 'react-i18next';

export const getRangeFilterValue = ({
  fromValue,
  toValue,
  units,
  t
}: {
  fromValue: number;
  toValue: number;
  units: string | ReactNode;
  t: TFunction<'translation', undefined>;
}) => {
  const fromText = t('search.form.from');
  const toText = t('search.form.to');
  const isUnitsString = typeof units === 'string';

  switch (true) {
    case !!fromValue && !!toValue: {
      return isUnitsString ? (
        `${fromValue} ${units} - ${toValue} ${units}`
      ) : (
        <>
          {fromValue} {units} - {toValue} {units}
        </>
      );
    }
    case !!fromValue: {
      return isUnitsString ? (
        `${fromText} ${fromValue} ${units}`
      ) : (
        <>
          {fromText} {fromValue} {units}
        </>
      );
    }
    case !!toValue: {
      return isUnitsString ? (
        `${toText} ${toValue} ${units}`
      ) : (
        <>
          {toText} {toValue} {units}
        </>
      );
    }
    default:
      return null;
  }
};
